import React, { Component } from "react";
import AddIcon from "@material-ui/icons/Add";
import Stepper from "../Stepper/Stepper";
import deleteItemsIcon from "../../../assets/image/delete_items.png";
import "./QuantityDistribution.scss";

let rowIdCounter = 0;
const makeRow = (perUnit = 1, unitsCount = 1) => ({
  id: ++rowIdCounter,
  perUnit,
  unitsCount,
});

const calcTotals = (rows) => {
  const totalItems = rows.reduce((sum, r) => sum + r.perUnit * r.unitsCount, 0);
  const totalUnits = rows.reduce((sum, r) => sum + r.unitsCount, 0);
  return { totalItems, totalUnits };
};

const DEFAULT_LABELS = {
  perUnit: "Кол-во на единицу",
  units: "Кол-во единиц",
  total: "Всего",
  available: "Доступно",
  plannedUnits: "Будет распределено",
  add: "Добавить",
};

class QuantityDistribution extends Component {
  constructor(props) {
    super(props);
    this.state = {
      rows: this.buildInitialRowsFromProps(props),
    };
  }

  buildInitialRowsFromProps = (props) => {
    const { availableTotal, defaultAmount } = props;
    if (typeof defaultAmount === "number" && defaultAmount > 0) {
      return [makeRow(defaultAmount, 1)];
    }
    const initialUnitsCount =
      typeof availableTotal === "number" && availableTotal > 0
        ? availableTotal
        : 1;
    return [makeRow(1, initialUnitsCount)];
  };

  componentDidMount() {
    this.notifyChange(this.state.rows);
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.availableTotal !== this.props.availableTotal ||
      prevProps.defaultAmount !== this.props.defaultAmount
    ) {
      const rows = this.buildInitialRowsFromProps(this.props);
      this.setState({ rows });
      this.notifyChange(rows);
    }
  }

  notifyChange = (rows) => {
    if (this.props.onChange) {
      this.props.onChange(rows, calcTotals(rows));
    }
  };

  updateRow = (id, key, value) => {
    const rows = this.state.rows.map((r) =>
      r.id === id ? { ...r, [key]: value } : r
    );
    this.setState({ rows });
    this.notifyChange(rows);
  };

  removeRow = (id) => {
    if (this.state.rows.length <= 1) return;
    const rows = this.state.rows.filter((r) => r.id !== id);
    this.setState({ rows });
    this.notifyChange(rows);
  };

  addRow = () => {
    const rows = [...this.state.rows, makeRow(1, 1)];
    this.setState({ rows });
    this.notifyChange(rows);
  };

  computeStepperMax = (row, key) => {
    const { availableTotal } = this.props;
    if (typeof availableTotal !== "number") return 999;

    const otherTotal = this.state.rows
      .filter((r) => r.id !== row.id)
      .reduce((sum, r) => sum + r.perUnit * r.unitsCount, 0);
    const remaining = availableTotal - otherTotal;
    if (remaining <= 0) {
      return key === "perUnit" ? row.perUnit : row.unitsCount;
    }
    const divider = key === "perUnit" ? row.unitsCount : row.perUnit;
    if (divider <= 0) return 999;
    return Math.max(1, Math.floor(remaining / divider));
  };

  render() {
    const { availableTotal, availableUnit, renderFooter } = this.props;
    const labels = { ...DEFAULT_LABELS, ...(this.props.labels || {}) };
    const { rows } = this.state;
    const totals = calcTotals(rows);
    const { totalItems, totalUnits } = totals;
    const canAddRow =
      typeof availableTotal !== "number" || totalItems < availableTotal;

    const formula = rows
      .map((r) => `${r.perUnit}×${r.unitsCount}`)
      .join(" + ");

    return (
      <div className="quantity_distribution">
        <div className="quantity_distribution__top">
          <span>
            {labels.available}:{" "}
            <span className="quantity_distribution__highlight">
              {availableTotal != null
                ? `${availableTotal}${availableUnit ? ` ${availableUnit}` : ""}`
                : "—"}
            </span>
          </span>
          <span>
            {labels.plannedUnits}:{" "}
            <span className="quantity_distribution__highlight">
              {totalUnits}
            </span>
          </span>
        </div>

        <div className="quantity_distribution__table-wrapper">
          <table className="quantity_distribution__table">
            <thead>
              <tr>
                <th>{labels.perUnit}</th>
                <th>{labels.units}</th>
                <th>{labels.total}</th>
                <th className="quantity_distribution__actions-col" aria-label="" />
              </tr>
            </thead>
            <tbody>
              {rows.map((row) => (
                <tr key={row.id}>
                  <td>
                    <div className="quantity_distribution__cell-content">
                      <Stepper
                        value={row.perUnit}
                        min={1}
                        max={this.computeStepperMax(row, "perUnit")}
                        onChange={(v) =>
                          this.updateRow(row.id, "perUnit", v)
                        }
                        size="small"
                        editable
                      />
                    </div>
                  </td>
                  <td>
                    <div className="quantity_distribution__cell-content">
                      <Stepper
                        value={row.unitsCount}
                        min={1}
                        max={this.computeStepperMax(row, "unitsCount")}
                        onChange={(v) =>
                          this.updateRow(row.id, "unitsCount", v)
                        }
                        size="small"
                        editable
                      />
                    </div>
                  </td>
                  <td>
                    <div className="quantity_distribution__cell-content">
                      {row.perUnit * row.unitsCount}
                    </div>
                  </td>
                  <td className="quantity_distribution__actions-col">
                    {rows.length > 1 && (
                      <button
                        type="button"
                        className="quantity_distribution__remove-btn"
                        onClick={() => this.removeRow(row.id)}
                      >
                        <img src={deleteItemsIcon} alt="delete" />
                      </button>
                    )}
                  </td>
                </tr>
              ))}
              <tr className="quantity_distribution__add-row">
                <td colSpan={4}>
                  <button
                    type="button"
                    className="quantity_distribution__add"
                    onClick={this.addRow}
                    disabled={!canAddRow}
                  >
                    <AddIcon fontSize="small" />
                    <span>{labels.add}</span>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        {renderFooter && (
          <div className="quantity_distribution__footer">
            {renderFooter({ ...totals, formula, rows })}
          </div>
        )}
      </div>
    );
  }
}

export default QuantityDistribution;
